import { Modal, Span } from "@virtual-brain-lib/frontend-design-system/ui";
import type { MessageToolMailboxData } from "@virtual-brain-lib/types";

import { MailRow } from "./MailRow";

interface ToolCardAllMailsModalProps {
	readonly isOpen: boolean;
	readonly close: () => void;
	readonly messages: MessageToolMailboxData["messages"];
	readonly contentReferenceOffset?: number;
}

export function ToolCardAllMailsModal({
	isOpen,
	close,
	messages,
	contentReferenceOffset,
}: ToolCardAllMailsModalProps) {
	const offset = contentReferenceOffset ?? 0;
	const reviewedMessages = offset > 0 ? messages.slice(0, offset) : [];
	const availableMessages = offset > 0 ? messages.slice(offset) : messages;

	return (
		<Modal
			close={close}
			icon="envelop"
			isOpen={isOpen}
			size="lg"
			classNames={{
				body: "p-0 max-h-[80vh]",
			}}
			footer={{
				secondaryButton: {
					hidden: true,
				},
			}}
			title={`All emails (${messages.length})`}
		>
			<div className="overflow-y-auto px-4 pt-4">
				{reviewedMessages.length === 0 ? (
					<div className="flex flex-col">
						{messages.map((message) => (
							<MailRow key={message.id} message={message} />
						))}
					</div>
				) : (
					<div className="mb-4 flex flex-col gap-6">
						<div className="flex flex-col gap-2">
							<div className="flex flex-col gap-0.5">
								<Span isBlock className="font-semibold" variant="body-sm">
									Reviewed ({reviewedMessages.length})
								</Span>
								<Span isBlock color="defaultLight" variant="body-xs">
									Taken into account when generating this answer.
								</Span>
							</div>
							<div className="border-subtle h-60 overflow-y-auto rounded-lg border bg-background p-2">
								{reviewedMessages.map((message) => (
									<MailRow key={message.id} message={message} />
								))}
							</div>
						</div>

						{availableMessages.length > 0 && (
							<div className="flex flex-col gap-2">
								<div className="flex flex-col gap-0.5">
									<Span isBlock className="font-semibold" variant="body-sm">
										Available for deeper analysis ({availableMessages.length})
									</Span>
									<Span isBlock color="defaultLight" variant="body-xs">
										Click 'Dig Deeper' in your deliverable to take these into
										account.
									</Span>
								</div>
								<div className="border-subtle h-60 overflow-y-auto rounded-lg border bg-secondary/20 p-2">
									{availableMessages.map((message) => (
										<MailRow key={message.id} message={message} />
									))}
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		</Modal>
	);
}
